// extracted by css-extract-rspack-plugin
export default {"functions":"functions__laNZv","select2":"select2__vcyu9","formElement":"formElement__lG3Dn"};